<template>
	<div class="container">
		<div class="content-wrapper">
			<small>Params: {{ $route.query }}</small>
			<h1>Join game</h1>
			<form action="">
				<label>Your name</label>
				<input v-model="name" placeholder="enter your name" />
				<label>Room code</label>
				<input v-model="roomCode" placeholder="enter the room code" />
				<button
					v-if="!game.joined"
					class="join"
					@click.prevent="handleJoin"
				>
					Join game
				</button>
				<button v-else class="leave" @click.prevent="handleLeave">
					Leave game
				</button>
				<button
					v-if="!connected"
					class="join"
					@click.prevent="tryConnect"
				>
					Connect to socket
				</button>
				<button v-else class="leave" @click.prevent="tryDisconnect">
					Disconnect from socket
				</button>
				<button class="join" @click.prevent="devTestEvent('Hello')">
					Send test event
				</button>
			</form>
			<h4>Log</h4>
			<!-- <p v-for="(error, index) in errors" :key="index">
				{{ error }}
			</p> -->
		</div>
		<div class="content-wrapper current-state">
			<h2>Current state</h2>
			<pre id="json">{{ JSON.stringify(fullState, null, "\t") }}</pre>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
	data() {
		return {
			name: this.$route.query.name || "Player name",
			roomCode: "1233",
		};
	},

	computed: {
		...mapGetters(["game", "players", "connected", "fullState"]),
		playerCount() {
			return this.players.filter(p => p == null).length + 1;
		},
	},
	methods: {
		...mapActions([
			"tryJoinGame",
			"tryLeaveGame",
			"tryConnect",
			"tryDisconnect",
			"devTestEvent",
		]),
		handleJoin() {
			// console.log("---- handleJoin called.");
			if (this.name && this.roomCode) {
				this.tryJoinGame({
					aRoomCode: this.roomCode,
					aName: this.name,
				});
			}
		},
		handleLeave() {
			if (this.game.id) {
				// console.log("handleLeave called");
				this.tryLeaveGame();
			}
		},
	},
	created() {
		// console.log("::: DEV.VUE");
		// console.log("Are we connected?", this.connected);
	},
	// beforeRouteLeave(to, from, next) {
	// 	// console.log("AM I JOINED???", this.joined);
	// 	next(false);
	// },
};
</script>

<style lang="scss" scoped>
.container {
	display: block;
	height: 100%;
	overflow: hidden;
}

form {
	* {
		display: block;
	}
	label {
		margin-bottom: 4px;
	}

	input {
		margin-top: 2px;
		margin-bottom: 12px;
		padding: 12px;
	}
}

.content-wrapper {
	vertical-align: top;
	display: inline-block;
	background-color: #ffffff22;
	padding: 24px;
	width: 400px;
}

.current-state {
	float: right;
	margin-right: 20px;
	width: fit-content;
	max-height: 100%;
	overflow: scroll;
}

pre {
	line-height: 20px;
	tab-size: 6;
}

button {
	padding: 10px 20px;
	color: white;
	transition: 0.2s;
	cursor: pointer;
	&.join {
		background-color: rgb(8, 170, 94);
		&:hover {
			background-color: lighten(rgb(8, 170, 94), 4%);
		}
	}
	&.leave {
		background-color: rgb(190, 35, 74);
	}
}

.errors {
	position: absolute;
	width: 40%;
	min-height: 80px;
	bottom: 16px;
	left: 16px;
	.error-box {
		display: block;
		margin: 8px 0;
	}
}

.error-fade-enter-active,
.error-fade-leave-active {
	transition: all 0.4s ease;
}
.error-fade-enter-from,
.error-fade-leave-to {
	opacity: 0;
}

.error-fade-move {
	transition: transform 0.4s ease;
}
</style>
